import React from 'react';
import cs from 'classnames';
import { FilterIcon } from '../../../assets/icons/filterIcon';

import SearchIcon2 from '../../../assets/icons/search.svg';
import styles from './SearchInput.module.scss';

type TSearchInput = React.InputHTMLAttributes<HTMLInputElement> & {
  placeHolder?: string;
  quickFilter?: boolean;
};

const SearchInput: React.FC<TSearchInput> = ({ onChange, className, placeHolder, onClick, value, quickFilter = false, ...rest }) => {
  return (
    <div className={cs(styles.searchContainer, className)} onClick={onClick}>
      {quickFilter ? <FilterIcon className={styles.filterIcon} /> : <img src={SearchIcon2} alt="search" />}
      <input value={value} onChange={onChange} placeholder={placeHolder ?? (quickFilter ? 'Quick Filter' : 'Search')} {...rest} />
    </div>
  );
};

export default SearchInput;
